import { render, staticRenderFns } from "./OrgaoEmissorSelect.vue?vue&type=template&id=a9bc10d6"
import script from "./OrgaoEmissorSelect.vue?vue&type=script&lang=js"
export * from "./OrgaoEmissorSelect.vue?vue&type=script&lang=js"
import style0 from "./OrgaoEmissorSelect.vue?vue&type=style&index=0&id=a9bc10d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports